import script from "./ProductionOverviewView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionOverviewView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__